import React, { useRef, useEffect } from 'react';

interface LocalhostModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const LocalhostModal: React.FC<LocalhostModalProps> = ({ isOpen, onClose }) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    if (isOpen && iframeRef.current) {
      iframeRef.current.onload = () => {
        try {
          // Seta window.opener na página do iframe
          if (iframeRef.current && iframeRef.current.contentWindow) {
            (iframeRef.current.contentWindow as any).opener = window;
          }
        } catch (e) {
          // Pode falhar por política de CORS
        }
      };
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      background: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
    }}>
      <div style={{ background: '#fff', padding: 20, borderRadius: 8, minWidth: 400 }}>
        <button onClick={onClose} style={{ float: 'right' }}>Fechar</button>
        <iframe
          ref={iframeRef}
          src="http://localhost:3333"
          title="Localhost Modal"
          style={{ width: 600, height: 400, border: 'none', marginTop: 20 }}
        />
      </div>
    </div>
  );
};

export default LocalhostModal;
